<div fxLayout="column">
  <ng-content select="[calculatorType]"></ng-content>

  <div fxLayout="row">
    <div fxFlex="50%" fxFlex.lt-lg="100%">
      <ng-content select="[calculatorName]"></ng-content>
      <ng-content select="[calculatorForm]"></ng-content>
    </div>
    <div fxFlex="50%" fxFlex.lt-lg="100%">
      <ng-content select="[calculatorResults]"></ng-content>
    </div>
  </div>

  <span></span>
  <ng-content select="[calculatorActions]"></ng-content>
</div>
